module.exports = __webpack_public_path__ + "static/Hund.io-0c16d535c785a3ecd1e4e162a89d7e72.svg";